export const updateStickyHeader = (className) => {
  // Make legacy header sticky
  const el = document.querySelector('.Header3');
  if (el) el.classList.add(className);
};

export const updateHeaderConfiguration = (configuration) => {
  // Set new header configuration
  if (window.LIFE_CYCLE_EVENT_BUS) {
    window.LIFE_CYCLE_EVENT_BUS.trigger('header.header-positioning-layout', { position: configuration })
  }
}

export const chunkArray = (arr, chunkSize) => {
  const chunkedArr = [];

  for (let i = 0; i < arr.length; i += chunkSize) {
    chunkedArr.push(arr.slice(i, i + chunkSize));
  }

  return chunkedArr;
}

export const getHasInStoreFilter = (appliedDimensions) => {
  return (appliedDimensions || [])
    .filter(({ label }) => label?.toUpperCase() === 'GET IT FAST')
    .find(({ refinements }) => refinements
      .find(({ label }) => label === 'Pick Up Today'));
}